module.exports = "/images/bannerOne-mobile.jpg";